import { FC } from 'react'
import cn from 'classnames'

import styles from './Typography.pcss'

interface Props {
	size?: 'XXL' | 'XL' | 'L' | 'M' | 'S' | 'XS'
	color?: 'black' | 'white' | 'gray' | 'green' | 'inherit'
	tag?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'div'
	align?: 'left' | 'center' | 'right'
	nowrap?: boolean
	className?: string
	onClick?: () => void
	children: React.ReactNode
}

const Typography: FC<Props> = ({
	size = 'M',
	color = 'black',
	tag = 'span',
	align = 'left',
	nowrap,
	children,
	className,
	onClick = () => {},
}) => {
	const Tag = tag
	const classNames = cn(
		styles.typography,
		nowrap && styles.nowrap,
		styles[`size-${size}`],
		styles[`color-${color}`],
		styles[`align-${align}`],
		className
	)

	return (
		<Tag className={classNames} onClick={onClick}>
			{children}
		</Tag>
	)
}

export default Typography
